import React, { useState } from "react";

function AdminLogin({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (username === "admin" && password === "admin123") {
      onLogin();
    } else {
      setError(true);
      setPassword("");
    }
  };

  return (
    <div className="bg-bg2 backdrop-blur-xl border border-borderBase p-10 rounded-2xl text-center max-w-[400px] w-full shadow-card">
      <h2 className="text-3xl font-extrabold mb-3">Admin Access</h2>
      <p className="text-textMuted mb-6">Please enter admin credentials to view the database index.</p>
      <form onSubmit={handleSubmit} className="text-left">
        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => {
            setUsername(e.target.value);
            setError(false);
          }}
          className={`w-full p-4 rounded-xl border bg-black/20 text-white font-sans text-base mb-3 transition-colors focus:outline-none ${error ? "border-[#ff3366] focus:border-[#ff3366]" : "border-borderBase focus:border-accentSolid"}`}
          autoFocus
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => {
            setPassword(e.target.value);
            setError(false);
          }}
          className={`w-full p-4 rounded-xl border bg-black/20 text-white font-sans text-base mb-2 transition-colors focus:outline-none ${error ? "border-[#ff3366] focus:border-[#ff3366]" : "border-borderBase focus:border-accentSolid"}`}
        />
        {error && <p className="text-[#ff3366] text-sm">Incorrect username or password.</p>}
        <button type="submit" className="w-full bg-accent-gradient text-white px-7 py-4 rounded-xl font-semibold shadow-glow hover:-translate-y-1 hover:shadow-glow-strong transition-all active:translate-y-px mt-4">
          Login
        </button>
      </form>
    </div>
  );
}

export default AdminLogin;
